module.exports = __webpack_public_path__ + "img/COMO_02_H.493a219c.jpg";